module.exports = __webpack_public_path__ + "media/images/icons/target-50c03d9c350f1423e9001331604e6772.png";